export default "__VITE_ASSET__CLIf$nfZ__"